var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contentsKey",class:{ 'contentsKey--loading': _vm.loading }},[(_vm.loading)?_c('loader'):_vm._e(),_vm._v(" "),_vm._t("default",null,{"content":_vm.content})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }